<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div id="compos">
    <div
      id="page_acknowledgement"
      class="container"
    >
      <!-- <div id="ad_result_1" /> -->
      <div class="box congrats_score">
        <center>
          <h3 class="congrats_title">
            <template v-if="score === 10">
              <span id="congrats_title">
                {{ $t('quiz.theone') }}
              </span>
            </template>
            <template v-else-if="score === 9">
              <span id="congrats_title">
                {{ $t('quiz.realfriend') }}
              </span>
            </template>
            <template v-else-if="score <= 8 && score > 6">
              <span id="congrats_title">
                {{ $t('quiz.goodfriend') }}
              </span>
            </template>
            <template v-else-if="score <= 6 && score > 4">
              <span id="congrats_title">
                {{ $t('quiz.regularfriend') }}
              </span>
            </template>
            <template v-else-if="score <= 4 && score > 2">
              <span id="congrats_title">
                {{ $t('quiz.badfriend') }}
              </span>
            </template>
            <template v-else>
              <span id="congrats_title">
                {{ $t('quiz.seriously') }}
              <!-- </span><span class="exclamationmark">
                ? -->
              </span>
            </template>
          </h3>
          <div
            id="gaugefy"
            class="gauge-container four"
          >
            <span class="value-min">
              0
            </span>
            <span class="value-max">
              10
            </span>
          </div>

          <div
            v-if="score === 10"
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.wow') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.believe', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
          <div
            v-else-if="score === 9"
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.yes') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.happy', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
          <div
            v-else-if="score <= 8 && score > 6"
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.cool') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.likeit', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
          <div
            v-else-if="score <= 6 && score > 4"
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.well') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.hope', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
          <div
            v-else-if="score <= 4 && score > 2"
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.low') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.wontlikeit', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
          <div
            v-else
          >
            <h3 class="page_ack_score_text">
              <span>
                {{ $t('quiz.meeh') }}
              </span><span id="score">
                {{ score }}<span><span>/</span>10</span>
              </span>
            </h3>
            <h4 class="page_ack_score_phrase">
              <span class="quiz_name">
                {{ $t('quiz.dontknow', { name: quizData.name }) }}
              </span>
            </h4>
          </div>
        </center>
      </div> <!-- box congrats_score -->

      <div class="box your_turn">
        <h4 class="your_turn_title">
          <span id="your_turn_title">
            {{ $t('quiz.createyours') }}
          </span><span class="exclamationmark">
            !
          </span>
        </h4>
        <h4 id="page_ack_create_msg">
          {{ $t('quiz.yourturn') }}
        </h4>

        <button
          id="create_poll_button"
          class="fullWidthButton button_2 pushdown"
          type="button"
          @click="goToCreatePoll()"
        >
          {{ $t('quiz.createbutton') }}
        </button>

        <h4 class="page_ack_note">
          <i class="far fa-window-restore" /><span id="page_ack_note">
            {{ $t('quiz.browsernote2') }}
          </span>
        </h4>
      </div>
      <!-- <div id="ad_result_2" /> -->
      <!-- 300x250 -->
      <!-- <div id="waldo-tag-15191" style="margin-bottom: 10px; text-align: center;"></div> -->
    </div>
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import Vue from 'vue'
import RaptiveAds from '@/plugins/raptive.js';

export default {
  name: 'ResultCompo',
  components: {
  },
  // eslint-disable-next-line
  props: [ 'quizData', 'score', 'friendName' ],
  data () {
    return {
      testScore: 0
      // playwireUnits: [
      //   {
      //     selectorId: 'ad_result_1',
      //     type: 'leaderboard_atf'
      //   },
      //   {
      //     selectorId: 'ad_result_2',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ]
    }
  },
  computed: {
  },
  watch: {
  },
  mounted: function () {
    Vue.use(RaptiveAds)
    // waldo.refreshTag('waldo-tag-15191')
    this.initGauge()
    // this.initTyche()
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API@Result is initialized')
    //   try {
    //     ramp.destroyUnits('all')
    //   } catch (e) {
    //     console.log('destroyUnits error: ', e)
    //   }
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    initGauge () {
      // eslint-disable-next-line
      let gaugefy = Gauge(
        document.getElementById('gaugefy'), {
          max: 10,
          dialStartAngle: 90,
          dialEndAngle: 0,
          showValue: true,
          color: function (value) {
            if (value < 1) {
              return '#fd8799'
            } else if (value < 5) {
              return '#ff5f77'
            } else if (value <= 9) {
              return '#2ed573'
            } else if (value <= 10) {
              return '#ffd65f'
            } else {
              return '#ef4655'
            }
          },
          value: 0
        }
      )
      setTimeout(() => {
        gaugefy.setValueAnimated(this.score, 2)
      }, 100)
    },
    goToCreatePoll () {
      window.location.href = '/'
    }
  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
